import { FaEdit, FaTrash } from 'react-icons/fa';

function UsageList({ usages, functionalUnits, selectedUsageId, onEdit, onDelete }) {
    return (
        <div className="audit-usage-list-container">
            <h2>Usages enregistrés</h2>
            <table>
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Unité</th>
                        <th>Usager</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {usages.map((usage) => (
                        <tr key={usage._id}>
                            <td>{usage.type_usage}</td>
                            <td>{functionalUnits.find(fu => fu.id === usage.functional_unit)?.name || '—'}</td>
                            <td>{usage.user_name || "Pas d'utilisateur"}</td>
                            <td className='edit-delete-icons'>
                                <FaEdit
                                    className={`edit-icon ${selectedUsageId === usage._id ? 'active' : ''}`}
                                    onClick={() => onEdit(usage)}
                                />
                                <FaTrash
                                    className="delete-icon"
                                    onClick={() => onDelete(usage._id)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default UsageList;
